// src/js/components/modal.js
export class Modal {
  constructor(selector = "#modalRoot") {
    this.el = document.querySelector(selector);
    if (!this.el) throw new Error(`Modal ${selector} not found`);
    this.contentEl = this.el.querySelector(".modal-content");
    this.closeBtn = this.el.querySelector(".modal-close");
    this.closeBtn?.addEventListener("click", () => this.close());
  }

  open(html = null) {
    if (html) this.setContent(html);
    this.el.classList.add("is-active");
  }

  close() {
    this.el.classList.remove("is-active");
    this.setContent(""); // clear old content
  }

  setContent(html) {
    this.contentEl.innerHTML = html;
  }
}
